import { Component, OnInit ,Inject} from '@angular/core';


import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { Employee } from './../../model/employee.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AreaData } from 'src/app/model/area.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.scss']
})
export class ControlComponent implements OnInit {

  areas:AreaData [];

selectedAreas=[]

roles :any[]=[]
selectedRoles: number[] = [];

changePasswordForm: FormGroup;
passwordMismatch: boolean = false;
isLoading:boolean = false;

constructor(  public dialogRef: MatDialogRef<ControlComponent>,
  @Inject(MAT_DIALOG_DATA) public data: Employee,
  private apiService: ApiService,
  private _snackBar: MatSnackBar, private fb: FormBuilder, private http: HttpClient){


    this.changePasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    });
  }
 
  ngOnInit(): void {
    this.getAreaData();
    this.getRolesData();

    this.selectedRoles = this.data.roles.map(role => role.roleId);
     this.selectedAreas = this.data.areas.map(area => area.areaCode);
  

     this.changePasswordForm.get('confirmPassword')?.valueChanges.subscribe(() => {
      this.checkPasswords();
    });

    this.changePasswordForm.get('newPassword')?.valueChanges.subscribe(() => {
      this.changePasswordForm.get('newPassword')?.markAsTouched();
    });
  }

  checkPasswords(): void {
    const newPassword = this.changePasswordForm.get('newPassword')?.value;
    const confirmPassword = this.changePasswordForm.get('confirmPassword')?.value;
    
    // Check if the new password and confirm password match
    this.passwordMismatch = newPassword !== confirmPassword;
  }




  onSubmit() {
    this.isLoading = true;
    const { newPassword, confirmPassword } = this.changePasswordForm.value;
    
    if (newPassword !== confirmPassword) {
      this.passwordMismatch = true;
      this.isLoading = false;
      return;
    }

    this.passwordMismatch = false;

    if (this.changePasswordForm.valid && !this.passwordMismatch) {

    let payload={
      employeeId:this.data.employeeId,
      employeePassword:newPassword
    }

    this.apiService.updatePassword(payload).subscribe(data => {
      if(data.success){
        this._snackBar.open('Password Changed successfully', 'Close', {
          duration: 3000,
        });
        this.isLoading = false;
        this.dialogRef.close();
      }else{
        this._snackBar.open('Failed to Change Password. Please Try Again after Some time!!', 'Close', {
          duration: 3000,
        });
        this.isLoading = false;
        this.dialogRef.close();
      }
      
    });
   }else{
    this.isLoading = false;
   }
  }

  getAreaData() {
    this.apiService.getAreaDetails()
      .subscribe(data => {
        this.areas = data.areas;
      });
  }
  selectAll() {
    this.selectedAreas = this.areas.map((area: AreaData) => area.areaCode);
  }

  deselectAll() {
    this.selectedAreas = [];
  }

  getRolesData() {
    this.apiService.getRolesDetails()
      .subscribe(data => {
       this.roles = data.roles;
      });
  }


  onNoClick(): void {
    this.dialogRef.close();
  }


  onRoleChange(roleId: number, isChecked: boolean): void {
    if (isChecked) {
      this.selectedRoles.push(roleId);
    } else {
      this.selectedRoles = this.selectedRoles.filter((id) => id !== roleId);
    }
  }

  updateEmployee(): void {
    const updatedEmployeeData = {
      employeeId: this.data.employeeId,
      roles: this.selectedRoles,
      areas: this.selectedAreas
    };

    this.apiService.updateEmployeeRolesAndAreas(updatedEmployeeData).subscribe(
      (response) => {
        console.log('Employee Roles and Area updated successfully:', response);
        this._snackBar.open('Employee Roles and Areas updated successfully', 'Close', {
          duration: 3000,
        });
        this.dialogRef.close(response);
      },
      (error) => {
        console.error('Error updating employee:', error);
        this._snackBar.open('Error in Updating Employee Roles and Areas ', 'Close', {
          duration: 3000,
        });
      }
    );
  }


}
